var map = {
	"./AR-Openpay-GO-UX-V02.svg": "36d2",
	"./LogotipoOpenpay_RGB-01 1.svg": "8d52",
	"./accounts-transfer-ok.png": "d10d",
	"./bbva-branch.png": "765c",
	"./computer_front_end.svg": "08ad",
	"./devices.png": "c6c0",
	"./digital_payment_device_dollar.svg": "432d",
	"./loan-dollar.png": "c9d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b5b";